/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { all } from 'redux-saga/effects';
import watchInitializeStatefulSaga from './initialize.stateful.saga';
import { watchMappedRoutesSaga } from './navigate.sagas';
import watchOrgChangeSaga from './org.change.saga';
import watchProxyReadySaga from './proxy.ready.saga';
import watchShowAccessChangesSaga from './show.access.changes.saga';

export default function* rootSaga() {
  yield all([
    watchInitializeStatefulSaga(),
    watchMappedRoutesSaga(),
    watchOrgChangeSaga(),
    watchProxyReadySaga(),
    watchShowAccessChangesSaga()
  ]);
}
